import { Model } from "../decorators/model.decorator";
import { Column } from "../decorators/column.decorator";
import { BaseModel } from "./base.model";

@Model('publisher', ['publishers'])
export class Publisher extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  name: string | undefined;
  @Column()
  url: string | undefined;
}
